export default "__VITE_ASSET__Ch5XivwO__"